module.exports = __webpack_public_path__ + "static/assets/aba7d7b900885d29395fd934a1563b8c.svg";